import FormControlLabel from "@material-ui/core/FormControlLabel";
import styled from "styled-components";
import { redesignTheme, theme } from "../../../theme/theme";
import { withStyles } from "@material-ui/core";

import Button from "../../../reusable/button";

export const StyledAlertTextBlock = styled.div`
  background-color: #faf0c7;
  color: #5e4003;
  padding: 6px 10px;
  border-radius: 8px;
  margin-bottom: 24px;

  & .fa-exclamation-triangle {
    padding-right: 10px;
    padding-top: 4px;
    color: #b37e00;
    vertical-align: top;
  }

  & .warning-text {
    display: inline-block;

    & p {
      margin-bottom: 0px;
    }
  }
`;

export const StyledArchivedCheckbox = styled.div`
  margin-top: 17px;
  margin-left: 16px;
`;

export const StyledBackLink = styled.div`
  &&& {
    font-size: ${theme.fontSize.l};
    margin: 20px 0px;
    color: ${theme.color.blue};
    &:hover {
      color: ${theme.color.blueDarkest};
      text-decoration: underline;
    }
  }

  & .fa-arrow-left {
    padding-right: 4px;
  }
`;

export const StyledButton = styled(Button)`
  box-shadow: none;
  margin-right: 16px;
  display: inline-block;
`;

export const StyledButtonNoMargin = styled(Button)`
  box-shadow: none;
  margin-right: 0;
  display: inline-block;
`;

export const StyledButton100 = styled(StyledButton)`
  width: 100px;
`;

export const StyledButtonContainer = styled.div`
  margin-top: 32px;
  text-align: left;
`;

export const StyledButtonContainerHalf = styled(StyledButtonContainer)`
  width: 50%;
`;

export const StyledButtonCreateItem = styled(Button)`
  box-shadow: none;
  width: 140px;
  display: inline-block;
`;

export const StyledButtonDeleteItem = styled(StyledButton100)`
  float: right;
  margin-right: 0px;
  background-color: #e8ebed;
  color: #48545b;

  &:hover,
  &:enabled:active {
    background-color: #d4d9dd;
  }
`;

export const StyledButtonMarginBottom = styled(Button)`
  margin-bottom: 15px;
`;

export const StyledCapitalizedText = styled.p`
  text-transform: capitalize;
  margin-bottom: 0px;
`;

export const StyledCheckboxHeader = styled.div`
  min-width: 70px;
`;

export const StyledCheckboxWrapper = styled.div`
  margin-left: -5px;
`;

export const StyledRowCheckboxWrapper = styled.div`
  margin-left: -17px;
`;

export const StyledContainer = styled.div`
  padding: 15px;
`;

export const StyledDeleteButton = styled(Button)`
  position: relative;
  margin-left: 5px;
  right: -100%;
  top: -80px;
  display: inline-block;
  vertical-align: top;
  width: 25px;
  height: 25px;
  box-shadow: none;
  background-color: #ffffff;
  border: 1px solid ${theme.color.gray300};

  &:hover {
    background-color: #f4f6f6;
    border: 1px solid ${theme.color.gray300};
  }
`;

export const StyledDeleteImage = styled.img`
  height: 16px;
  position: absolute;
  bottom: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
`;

export const StyledDenominationButton = styled.button`
  font-family: ${theme.fontFamily};
  font-size: ${theme.fontSize.m};
  margin: 2px;
  padding: 6px 12px;
  border: none;
  border-radius: ${theme.radius.s};

  &:hover {
    cursor: pointer;
  }

  &:hover:disabled {
    cursor: not-allowed;
  }
`;

export const StyledDenominationButtonGray = styled(StyledDenominationButton)`
  background-color: #f4f6f6;
  color: ${theme.color.gray600};

  &:hover {
    cursor: default;
  }
`;

export const StyledDenominationButtonGreen = styled(StyledDenominationButton)`
  background-color: ${theme.color.green200};
  color: ${theme.color.green800};

  &:hover:enabled {
    background-color: ${theme.color.green400};
  }
`;

export const StyledDenominationButtonLightGray = styled(
  StyledDenominationButton
)`
  background-color: ${theme.color.white};
  color: ${theme.color.gray300};

  &:hover {
    cursor: default;
  }
`;

export const StyledDenominationButtonRed = styled(StyledDenominationButton)`
  background-color: ${theme.color.red200};
  color: ${theme.color.red800};

  &:hover:enabled {
    background-color: ${theme.color.red400};
  }
`;

export const StyledErrorMessage = styled.p`
  color: ${theme.color.red};
`;

export const StyledErrorMessageLeftMargin = styled(StyledErrorMessage)`
  margin-left: 16px;
`;

export const StyledFilterRow = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledForm = styled.div`
  background: ${theme.color.white};
  border-radius: ${theme.radius.m};
  box-shadow: 0px 2px 4px rgba(46, 53, 56, 0.25);
  padding: 24px 42px;
`;

export const StyledFormControlLabel = withStyles(() => {
  return {
    label: {
      color: `${theme.color.gray800}`,
      fontFamily: `${theme.fontFamily}`,
      fontSize: `${theme.fontSize.m}`,
    },
    root: {
      height: "26px",
      marginRight: "5px",
    },
  };
})(FormControlLabel);

export const StyledFormField = styled.div`
  margin-bottom: 24px;
  width: 50%;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledHelperDiv = styled.div`
  margin-bottom: 14px;
  font-family: ${theme.fontFamily};
  color: ${theme.color.gray500};
  font-size: ${theme.fontSize.s};
`;

export const StyledHelperText = styled.div`
  margin-bottom: 14px;
  font-family: ${theme.fontFamily};
  color: ${theme.color.gray500};
  font-size: ${theme.fontSize.s};
`;

export const StyledHelperTextWithMargin = styled(StyledHelperText)`
  margin-top: 14px;
  margin-left: 28px;
`;

export const StyledInput = styled.input`
  &&& {
    width: 100%;
    height: 46px;
    padding: 14px;
    border: 1px solid ${theme.color.gray300};
    border-radius: ${theme.radius.s};
    font-family: ${theme.fontFamily};
    color: ${theme.color.gray800};
    font-size: ${theme.fontSize.m};
    box-sizing: border-box;
    ::placeholder {
      color: ${theme.color.gray500};
    }
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const StyledInstruction = styled.p`
  font-size: 12px;
`;

export const StyledLabel = styled.label`
  width: 100%;
  margin-bottom: 14px;
  font-family: ${theme.fontFamily};
  font-weight: ${theme.fontWeight.bold};
  color: ${theme.color.gray800};
  font-size: ${theme.fontSize.s};
  cursor: text;
`;

export const StyledLink = styled.a`
  color: ${theme.color.blueLink};
  text-decoration: underline;
  &:hover {
    color: ${theme.color.purple};
  }
`;

export const StyledListItem = styled.li`
  margin-left: 24px;
  list-style-type: circle;
`;

export const StyledModalBody = styled.div`
  margin: ${redesignTheme.spacing[4.5]} 0;
`;

export const StyledModalButtonContainer = styled.div`
  border-top: 1px solid ${redesignTheme.color.grayAlpha100};
  margin-top: 16px;
  padding: 16px 24px 0 24px;
  text-align: right;
  display: flex;
  justify-content: space-between;
`;

export const StyledModalContents = styled.div`
  border-top: 1px solid ${redesignTheme.color.grayAlpha100};
  padding: 16px 24px 0 24px;
`;

export const StyledPageLoaderContainer = styled.div`
  text-align: center;
  margin: 300px auto;
  width: 100%;
`;

export const StyledPageHeader = styled.h1`
  flex-basis: 100%;
`;

export const StyledParagraph = styled.p`
  margin: 16px;
`;

export const StyledParagraphNoMargin = styled.p`
  margin-bottom: 0px;
`;

export const StyledProviderSelect = styled.div`
  width: 200px;
  margin-left: 16px;
  margin-bottom: 16px;
`;

export const StyledRequired = styled.span`
  color: ${theme.color.red400};
`;

export const StyledSpacer14 = styled.div`
  height: 14px;
`;

export const StyledSpan = styled.span`
  padding-left: 9px;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  max-width: 100%;
  height: 150px;
  resize: auto;
  margin-top: 0px;
  margin-bottom: 14px;
  padding: 16px;
  border-radius: ${theme.radius.s};
  border: 1px solid ${theme.color.gray300};
  display: block;
`;

export const StyledWarningTextarea = styled.textarea`
  width: 100%;
  height: 75px;
  resize: none;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 16px;
  border-radius: ${theme.radius.s};
  border: 1px solid ${theme.color.gray300};
`;
